import { render, staticRenderFns } from "./KpiSetting.vue?vue&type=template&id=54fc4ce0&"
import script from "./KpiSetting.vue?vue&type=script&lang=js&"
export * from "./KpiSetting.vue?vue&type=script&lang=js&"
import style0 from "./KpiSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54fc4ce0')) {
      api.createRecord('54fc4ce0', component.options)
    } else {
      api.reload('54fc4ce0', component.options)
    }
    module.hot.accept("./KpiSetting.vue?vue&type=template&id=54fc4ce0&", function () {
      api.rerender('54fc4ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/GuideChildren/KpiSetting.vue"
export default component.exports